import { Component, OnInit, Input } from '@angular/core';
import { first } from 'rxjs/operators';
import { UserService } from '../../../service/user.service';
import { UserSessionService } from '../../../_client-service/user-session.service';
import { User } from '../../../model/user';
import { ChangePwdModel } from '../../../model/changepwdmodel';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from 'src/app/dialog/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

    @Input() forwardUrl: string;
    changePwdForm: any = {};
    user: User;
    newPasswordMsg = {
        isError: false,
        message: 'La password non deve contenere spazi bianchi'
    };
    newPasswordCheckMsg = {
        isError: false,
        message: ''
    };

    constructor(
        private router: Router,
        private userSrv: UserService,
        private userSessionSrv: UserSessionService,
        private alertDialog: MatDialog
    ) { }

    ngOnInit() {
        this.user = this.userSessionSrv.getUser();
        this.userSessionSrv.onUserChange.subscribe((user: User) => this.user = user);
    }

    changePassword() {
        if (this.validateForm()) {
            const changePwdModel = new ChangePwdModel();
            changePwdModel.email = this.user.email;
            changePwdModel.oldPassword = this.changePwdForm.oldPassword;
            changePwdModel.newPassword = this.changePwdForm.newPassword;
            changePwdModel.newPasswordCheck = this.changePwdForm.newPasswordCheck;
            this.userSrv.changePassword(changePwdModel)
                .pipe(first())
                .subscribe(
                    data => {
                        if (data.outcome === 'OK') {
                            const alertDialogRef = this.alertDialog.open(AlertDialogComponent, {
                                data: {
                                    title: 'Cambio Password',
                                    message: 'Password modificata correttamente'
                                }
                            });

                            alertDialogRef.afterClosed().subscribe(result => {
                                this.router.navigate([this.forwardUrl]);
                            });
                        } else {
                            this.router.navigate(['/p/cambio-password']);
                        }
                    },
                    error => {
                        // this.error = error;
                        // this.loading = false;
                    }
                );
        }
    }

    validateForm(): boolean {
        let isValid = true;
        if (this.changePwdForm.newPassword == null || this.changePwdForm.newPassword.trim() === '') {
            isValid = false;
            this.newPasswordMsg.isError = true;
            this.newPasswordMsg.message = 'Campo obbligatorio';
        } else if (this.changePwdForm.newPassword.includes(' ')) {
            isValid = false;
            this.newPasswordMsg.isError = true;
            this.newPasswordMsg.message = 'La nuova password contiene caratteri non validi';
        } else if (this.changePwdForm.newPasswordCheck == null || this.changePwdForm.newPasswordCheck.trim() === '') {
            isValid = false;
            this.newPasswordCheckMsg.isError = true;
            this.newPasswordCheckMsg.message = 'Campo obbligatorio';
        } else if (this.changePwdForm.newPassword !== this.changePwdForm.newPasswordCheck) {
            isValid = false;
            this.newPasswordCheckMsg.isError = true;
            this.newPasswordCheckMsg.message = 'Le password non corrispondono';
        }
        return isValid;
    }

}
